import {useEffect} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';
import {BlogArticle, BlogCatalog} from '@app/blog/use-public-blog';

/** Прогревает react-query из bootstrap, чтобы переходы по /blog не мигали. */
export function useHydratePublicBlogCache() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const loader = getBootstrapData().loaders?.publicBlog as
      | {locale?: string; catalog?: BlogCatalog; article?: BlogArticle | null}
      | undefined;
    if (!loader) {
      return;
    }

    const locale = loader.locale ?? 'en';
    if (loader.catalog) {
      queryClient.setQueryData(['public-blog', 'catalog', locale], loader.catalog);
    }
    if (loader.article) {
      queryClient.setQueryData(
        ['public-blog', 'article', loader.article.slug],
        loader.article,
      );
    }
  }, [queryClient]);
}
